import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  AcceptInviteSuccess,
  RejectInviteSuccess,
} from '../../invites/action-creators';
import {
  ACCEPT_INVITE_SUCCESS,
  REJECT_INVITE_SUCCESS,
} from '../../invites/actions';
import AppState from '../../state';
import { NoOp } from '../../ui/action-creators';
import { UpdateNotificationInvite } from '../action-creators';

export const inviteStatusChangedEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, AcceptInviteSuccess | RejectInviteSuccess>(
      ACCEPT_INVITE_SUCCESS,
      REJECT_INVITE_SUCCESS
    ),
    withLatestFrom(state$),
    map(([action, state]) => {
      const id = action.invite.id;

      const notification = state.notifications.items.find(
        (n) => n.invite?.id === id
      );

      if (!notification) {
        return new NoOp();
      }

      return new UpdateNotificationInvite(
        notification.id,
        action.type === ACCEPT_INVITE_SUCCESS ? 'accepted' : 'rejected'
      );
    })
  );
